
import React, { useEffect, useState } from "react";
import { fetch_share_holders_data } from "../../ApisService/apiService";
import styles from "../../../css/dashboard/fundamental/Profitloss.module.css";


const Investors = ({ selectedCompany }) => {
  const [Shareholders, setShareholders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedRows, setExpandedRows] = useState({});

  useEffect(() => {
    if (!selectedCompany || !selectedCompany.fincode) {
      setShareholders([]);
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const Share_holders = await fetch_share_holders_data(selectedCompany.fincode);
        setShareholders(Share_holders.data || []);
      } catch (err) {
        setError("Failed to fetch data.");
      }
      setLoading(false);
    };

    fetchData();
  }, [selectedCompany]);

  const toggleRowVisibility = (key) => {
    setExpandedRows((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  if (!selectedCompany) {
    return <p className={styles.errorText}>No company selected.</p>;
  }

  const years = Shareholders.map((item) => item.DATE_END);

  const financialData = [
    // { type: "data", label: " Year End", key: "DATE_END", },
    { type: "data", label: " Indian Promoter", key: "nhINDSubtotal", },
    { type: "data", label: " Foreign Promoter", key: "nhFSubtotal", },
    { type: "data", label: " Total Promoter", key: "nhFtotalpromoter", },
    { type: "data", label: " Mutual Funds / UTI", key: "nhINMFUTI", },
    { type: "data", label: " Govt", key: "nhINcgovt", },
    { type: "data", label: " FII", key: "nhINFII", },
    { type: "data", label: " Other", key: "Other_one", },
    // { type: "data", label: " Other", key: "Isnull(nhINSubtotal,0)-Isnull(nhINMFUTI,0)-Isnull(nhINFIBanks,0)-Isnull(nhINInsurance,0)-Isnull(nhINcgovt,0)", },
    { type: "data", label: "Institutions", key: "nhINSubtotal", },
    { type: "data", label: " Individuals", key: "nhNINIndivd", },
    { type: "data", label: " Others", key: "Others_two", },
    // { type: "data", label: " Others", key: "Isnull(nhNINSubtotal,0)-Isnull(nhNINbodyCorp,0)-Isnull(nhNINIndivd,0)-Isnull(nhNINNRI,0)", },
    { type: "data", label: " Non-Institution", key: "nhNINSubtotal", },
    { type: "data", label: " Public", key: "nhTotalpublic", },
    { type: "data", label: " Depository Receipts", key: "nhCustodianDRs", },
    { type: "data", label: " Grand Total", key: "nhGrandTotal", },


  ];


  const formatFincode = (fincode) => {
    const fincodeNumber = parseInt(fincode, 10);
    const year = Math.floor(fincodeNumber / 100);
    const month = fincodeNumber % 100;
    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'June',
      'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'
    ];
    return `${year}-${monthNames[month - 1]}`;
  };
  const getSafeNumber = (val) => {
    if (val === undefined || val === null || val === "") return 0; // Fallback for empty values
    const cleaned = String(val).replace(/,/g, "").trim(); // Remove commas and whitespace
    const num = parseFloat(cleaned); // Try converting to float
    return isNaN(num) ? 0 : num; // If not a number, fallback to 0
  };



  return (
    <div className={styles.container}>
      <h2 className={styles.title}>
        Financial Data ({selectedCompany.fincode})
      </h2>

      {loading ? (
        <p className={styles.loadingText}>Loading...</p>
      ) : error ? (
        <p className={styles.errorText}>{error}</p>
      ) : Shareholders.length === 0 ? (
        <p className={styles.noDataText}>No data available.</p>
      ) : (
        <div className={styles.tableContainer}>
          <table className={`table-sm ${styles.table}`}>
            <thead>
              <tr>
                <th className={styles.tableHeader}>Metrics</th>
                {years.map((year, index) => (
                  <th key={index} className={styles.tableHeader}>
                    {formatFincode(year)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {financialData.map((item, index) => {
                if (item.type === "heading") {
                  return (
                    <tr key={index} className={styles.sectionRow}>
                      <td colSpan={years.length + 1} className={styles.sectionHeader}>
                        {item.label}
                      </td>
                    </tr>
                  );
                }

                if (item.type === "data") {
                  return (
                    <React.Fragment key={index}>
                      <tr className={styles.tableRow}>
                        <td className={styles.tableCell}>
                          {item.expandable ? (
                            <button
                              onClick={() => toggleRowVisibility(item.key)}
                              className={styles.toggleButton}
                            >
                              {expandedRows[item.key] ? "-" : "+"} {item.label}
                            </button>
                          ) : (
                            item.label
                          )}
                        </td>
                        {Shareholders.map((data, idx) => (
                          <td key={idx} className={styles.tableCell}>
                            {(() => {
                              if (item.key === "Other_one") {
                                const subtotal = getSafeNumber(data.nhINSubtotal);
                                const mfUti = getSafeNumber(data.nhINMFUTI);
                                const fiiBanks = getSafeNumber(data.nhINFIBanks);
                                const insurance = getSafeNumber(data.nhINInsurance);
                                const govt = getSafeNumber(data.nhINcgovt);
                                return (subtotal - mfUti - fiiBanks - insurance - govt).toFixed(2);
                              } else if (item.key === "Others_two") {
                                const subtotal = getSafeNumber(data.nhNINSubtotal);
                                const bodyCorp = getSafeNumber(data.nhNINbodyCorp);
                                const indivd = getSafeNumber(data.nhNINIndivd);
                                const nri = getSafeNumber(data.nhNINNRI);
                                return (subtotal - bodyCorp - indivd - nri).toFixed(2);
                              } else {
                                return data[item.key] ?? "–";
                              }
                            })()}


                          </td>
                        ))}

                      </tr>


                    </React.Fragment>
                  );
                }

                return null;
              })}
            </tbody>

          </table>
        </div>
      )}
    </div>
  );
};

export default Investors;
